import React, { useState, useEffect, useRef } from "react";
import BlockUi from "react-block-ui";
import { Card } from "react-bootstrap";
import ReCAPTCHA from "react-google-recaptcha";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import PhoneInput from "react-phone-input-2";
import {
  Avatar,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@material-ui/core";

import ServiceLoginModel from "../Forms/ServiceLandingV2/ServiceLoginModel";
import RazorPay from "../../components/RazorPay";
import ProfileService from "../../api/ProfileService";
import MyYuukke from "../../api/MyYuukke"; 
import { API_URL, BASE_URL, REACT_APP_SITE_KEY } from "../../config/app-config";
import {
  getCategoryListV2,
  getSubscriptionList,
} from "../../redux/actions/calendarAction";
import { getAllCommonLanguageList } from "../../redux/actions/commonApiActions";

import headerImg from "../../images/service/yuukke-logo.png";
import playStore from "../../images/service/Playstore logo.png";
import appleStore from "../../images/service/Apple logo.png";
import { withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";
import i18n from "../../i18n";

import entrepreneur from "../../images/service/Entrepreneur.svg";
import dtNext from "../../images/service/DT NEXT.svg";
import yourStory from "../../images/service/Your story.svg";
import zeeNews from "../../images/service/Zee News.svg";
import toi from "../../images/service/TOI.svg";
import serviceImageDemo from "../../images/service/serviceDemoImage.png";

import "./YuukkeLanding.css";
import BlogSection from "./BlogSection";
import EnquiryDialog from "../../components/EnquiryDialog";
import { Helmet } from "react-helmet";

// ─────────────────────────────────────────────────────────────────────────────
// HELPERS
// ─────────────────────────────────────────────────────────────────────────────
function useScrollReveal() {
  useEffect(() => {
    const els = document.querySelectorAll(
      ".yk2-reveal,.yk2-reveal-left,.yk2-reveal-right,.yk2-reveal-scale",
    );
    const io = new IntersectionObserver(
      (entries) =>
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("yk2-vis");
            io.unobserve(e.target);
          }
        }),
      { threshold: 0.12 },
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);
}

function ripple(e) {
  const btn = e.currentTarget;
  const rect = btn.getBoundingClientRect();
  const size = Math.max(rect.width, rect.height);
  const el = document.createElement("span");
  el.className = "yk2-ripple-el";
  el.style.cssText = `width:${size}px;height:${size}px;top:${
    e.clientY - rect.top - size / 2
  }px;left:${e.clientX - rect.left - size / 2}px`;
  btn.appendChild(el);
  el.addEventListener("animationend", () => el.remove());
}

function getPlanMeta(sub) {
  switch (sub.subscribeType) {
    case "FREE_TRIAL":
      return {
        duration: "Free Trial",
        billing: "No credit card required",
        badge: "TRY FREE",
        badgeColor: "#2563eb",
        priceSuffix: "",
      };
    case "YEARLY":
      return {
        duration: "Billed Yearly",
        billing: "Renews every 365 days",
        badge: "MOST FLEXIBLE",
        badgeColor: "#7a0024",
        priceSuffix: "/year",
      };
    case "LIFETIME":
      return {
        duration: "One-Time Payment",
        billing: "Pay once, use forever",
        badge: "BEST VALUE",
        badgeColor: "#15803d",
        priceSuffix: "one-time",
      };
    default:
      return {
        duration: "",
        billing: "",
        badge: null,
        badgeColor: "#7a0024",
        priceSuffix: "",
      };
  }
}

function ServicePageShowcase() {
  return (
    <div className="yk2-livepreview-wrap" style={{ padding: "2rem 1.5rem", maxWidth: 1200, margin: "0 auto" }}>
      <div style={{ marginBottom: "1.25rem", textAlign: "center" }}>
        <h3 style={{ fontSize: "1.1rem", fontWeight: 700, color: "#7a0024", margin: "0 0 4px" }}>
          See it in action
        </h3>
        <p style={{ fontSize: 13, color: "#6b4550", margin: 0 }}>
          This is what your service booking page will look like.
        </p>
      </div>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <img src={serviceImageDemo} alt="Yuukke service booking page preview" loading="lazy" style={{ width: "100%", maxWidth: 900, borderRadius: 16, border: "1px solid #f0dde3", boxShadow: "0 8px 24px rgba(122,0,36,0.08)", display: "block" }} />
      </div>
    </div>
  );
}

function OtpInput({ length = 6, onOtpSubmit }) {
  const [otp, setOtp] = useState(Array(length).fill(""));
  const inputs = useRef([]);
  const handleChange = (i, val) => {
    if (!/^\d?$/.test(val)) return;
    const next = [...otp];
    next[i] = val;
    setOtp(next);
    onOtpSubmit(next.join(""));
    if (val && i < length - 1) inputs.current[i + 1]?.focus();
  };
  const handleKeyDown = (i, e) => {
    if (e.key === "Backspace" && !otp[i] && i > 0) inputs.current[i - 1]?.focus();
  };
  return (
    <div style={{ display: "flex", gap: 8, justifyContent: "center" }}>
      {otp.map((digit, i) => (
        <input
          key={i}
          ref={(el) => (inputs.current[i] = el)}
          type="text"
          inputMode="numeric"
          maxLength={1}
          value={digit}
          onChange={(e) => handleChange(i, e.target.value)}
          onKeyDown={(e) => handleKeyDown(i, e)}
          style={{ width: 44, height: 52, textAlign: "center", fontSize: 22, fontWeight: 700, border: digit ? "2px solid #7a0024" : "2px solid #e0e0e0", borderRadius: 10, outline: "none", background: digit ? "#fff8f9" : "#fff", color: "#7a0024", transition: "border-color 0.2s, background 0.2s", caretColor: "#7a0024" }}
          onFocus={(e) => { e.target.style.borderColor = "#7a0024"; e.target.style.boxShadow = "0 0 0 3px rgba(122,0,36,0.1)"; }}
          onBlur={(e) => { e.target.style.borderColor = digit ? "#7a0024" : "#e0e0e0"; e.target.style.boxShadow = "none"; }}
        />
      ))}
    </div>
  );
}

function FormStepBar({ active, total }) {
  return (
    <div className="yk2-form-step-bar">
      {Array.from({ length: total }, (_, i) => (
        <React.Fragment key={i}>
          <div className={`yk2-form-step-dot ${i < active ? "done" : i === active ? "active" : ""}`}>
            {i < active ? "✓" : i + 1}
          </div>
          {i < total - 1 && <div className={`yk2-form-step-line${i < active ? " done" : ""}`} />}
        </React.Fragment>
      ))}
    </div>
  );
}

function PhoneUpdateModal({ open, onClose, existingUser, newPhone, onSuccess }) {
  const [step, setStep] = useState(0);
  const [typedOldPhone, setTypedOldPhone] = useState("");
  const [typedNewPhone, setTypedNewPhone] = useState("");
  const [oldOtpSent, setOldOtpSent] = useState(false);
  const [oldOtpId, setOldOtpId] = useState(null);
  const [newOtpId, setNewOtpId] = useState(null);
  const [oldOtp, setOldOtp] = useState("");
  const [newOtp, setNewOtp] = useState("");
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    if (open) {
      setStep(0);
      setTypedOldPhone("");
      setTypedNewPhone(newPhone || "");
      setOldOtpSent(false);
      setOldOtpId(null);
      setNewOtpId(null);
      setOldOtp("");
      setNewOtp("");
    }
  }, [open, newPhone]);

  const maskPhone = (phone) => {
    if (!phone) return "XXXXXXXXXX";
    const str = String(phone);
    if (str.length <= 4) return str;
    return str.slice(0, 2) + "X".repeat(Math.max(str.length - 4, 4)) + str.slice(-2);
  };

  const sendOtpToPhone = (phoneNumber, onSuccessCallback) => {
    setLoader(true);
    ProfileService.sendOtp({ type: "phone", phoneNumber: phoneNumber, optModelName: "Service" })
      .then((res) => {
        setLoader(false);
        if (res.data.data?.id) onSuccessCallback(res.data.data.id);
        else toast.error("Failed to send OTP — " + (res.data.message || "try again"));
      })
      .catch(() => { toast.error("Something went wrong"); setLoader(false); });
  };

  const handleConfirmChange = () => setStep(1);

  const handleSendOtpToRegistered = () => {
    if (!typedOldPhone || typedOldPhone.length < 6) { toast.warning("Enter your registered phone number"); return; }
    setLoader(true);
    ProfileService.verifyUserPhone({ email: existingUser.email, phoneNumber: typedOldPhone })
      .then((res) => {
        setLoader(false);
        if (res.data.status === 1) {
          sendOtpToPhone(typedOldPhone, (id) => { setOldOtpId(id); setOldOtpSent(true); toast.success("OTP sent to your registered number"); });
        } else if (res.data.status === 0) {
          toast.error("This number doesn't match your registered number. Please check and try again.");
        } else {
          toast.error("User not found. Please contact support.");
        }
      })
      .catch(() => { toast.error("Something went wrong"); setLoader(false); });
  };

  const verifyOldOtpAndProceed = () => {
    if (!oldOtp || oldOtp.length !== 6) { toast.warning("Enter valid 6-digit OTP"); return; }
    if (!oldOtpId) { toast.error("OTP session expired — please resend"); return; }
    setLoader(true);
    ProfileService.validateUserOtp({ otp: oldOtp, id: oldOtpId })
      .then((res) => {
        setLoader(false);
        if (res.data.data === "VALID_OTP") {
          setLoader(true);
          ProfileService.sendOtp({ type: "phone", phoneNumber: typedNewPhone, optModelName: "Service" })
            .then((otpRes) => {
              setLoader(false);
              if (otpRes.data.data?.id) { setNewOtpId(otpRes.data.data.id); setStep(2); toast.success("OTP sent to your new number"); }
              else toast.error("Failed to send OTP to new number");
            })
            .catch(() => { toast.error("Something went wrong sending OTP"); setLoader(false); });
        } else toast.error("Wrong OTP, try again");
      })
      .catch(() => { toast.error("Something went wrong"); setLoader(false); });
  };

  const verifyNewOtpAndUpdate = () => {
    if (!newOtp || newOtp.length !== 6) { toast.warning("Enter valid 6-digit OTP"); return; }
    if (!newOtpId) { toast.error("OTP session expired — please resend OTP"); return; }
    setLoader(true);
    ProfileService.validateUserOtp({ otp: newOtp, id: newOtpId })
      .then((res) => {
        setLoader(false);
        if (res.data.data === "VALID_OTP") {
          setLoader(true);
          ProfileService.updateUserPhoneNumber({ userId: existingUser.userId, phoneNumber: typedNewPhone })
            .then((res) => {
              setLoader(false);
              if (res.data.status === 1) setStep(3);
              else toast.error("Phone update failed, please try again");
            })
            .catch(() => { toast.error("Something went wrong"); setLoader(false); });
        } else toast.error("Wrong OTP — " + (res.data.data || "try again"));
      })
      .catch(() => { toast.error("Something went wrong"); setLoader(false); });
  };

  const StepIndicator = () => (
    <div style={{ display: "flex", alignItems: "center", margin: "16px 0 4px" }}>
      {[{ label: "Verify Current" }, { label: "Verify New" }, { label: "Done" }].map((s, i) => {
        const activeIdx = step === 1 ? 0 : step === 2 ? 1 : 2;
        const done = i < activeIdx;
        const active = i === activeIdx;
        return (
          <React.Fragment key={i}>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", flex: 1 }}>
              <div style={{ width: 30, height: 30, borderRadius: "50%", background: done ? "#22c55e" : active ? "#7a0024" : "#e5e7eb", color: done || active ? "#fff" : "#9ca3af", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 13, fontWeight: 700, transition: "all 0.3s" }}>
                {done ? "✓" : i + 1}
              </div>
              <span style={{ fontSize: 10, marginTop: 4, color: active ? "#7a0024" : done ? "#22c55e" : "#9ca3af", fontWeight: active || done ? 600 : 400, whiteSpace: "nowrap" }}>
                {s.label}
              </span>
            </div>
            {i < 2 && <div style={{ flex: 1, height: 2, marginBottom: 18, background: done ? "#22c55e" : "#e5e7eb", transition: "background 0.3s" }} />}
          </React.Fragment>
        );
      })}
    </div>
  );

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <style>{`
        .pum-inner .react-tel-input .form-control { width: 100% !important; height: 44px !important; font-size: 14px !important; padding-left: 50px !important; border: 1px solid #e0e0e0 !important; border-radius: 8px !important; box-sizing: border-box !important; background: #fff !important; }
        .pum-inner .react-tel-input .flag-dropdown { border: 1px solid #e0e0e0 !important; border-right: none !important; border-radius: 8px 0 0 8px !important; background: #fafafa !important; }
        .pum-inner .react-tel-input { width: 100% !important; }
      `}</style>
      {step === 0 && (
        <>
          <DialogTitle style={{ borderBottom: "1px solid #f0f0f0" }}><span style={{ fontSize: 16, fontWeight: 600 }}>Change Phone Number?</span></DialogTitle>
          <DialogContent style={{ padding: "1.5rem" }}>
            <div style={{ textAlign: "center" }}>
              <div style={{ fontSize: 48, marginBottom: 16 }}>🔐</div>
              <Typography variant="body1" style={{ fontWeight: 600, marginBottom: 12, color: "#222" }}>Are you sure you want to change your registered number?</Typography>
              <div style={{ background: "#f8f9fa", border: "1px solid #e9ecef", borderRadius: 12, padding: "14px 18px", marginBottom: 16, display: "flex", alignItems: "center", gap: 12 }}>
                <div style={{ width: 40, height: 40, borderRadius: "50%", background: "#fff3cd", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}><span style={{ fontSize: 20 }}>📱</span></div>
                <div style={{ textAlign: "left" }}>
                  <Typography variant="caption" color="textSecondary" style={{ display: "block", marginBottom: 2 }}>Currently registered number</Typography>
                  <Typography variant="body1" style={{ fontWeight: 700, letterSpacing: 2, color: "#222" }}>+{maskPhone(existingUser?.mobileNumber)}</Typography>
                </div>
              </div>
              <div style={{ background: "#fff8f9", border: "1px solid #f0dde3", borderRadius: 12, padding: "14px 18px", marginBottom: 20, display: "flex", alignItems: "center", gap: 12 }}>
                <div style={{ width: 40, height: 40, borderRadius: "50%", background: "#fce4ec", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}><span style={{ fontSize: 20 }}>🆕</span></div>
                <div style={{ textAlign: "left" }}>
                  <Typography variant="caption" color="textSecondary" style={{ display: "block", marginBottom: 2 }}>New number to register</Typography>
                  <Typography variant="body1" style={{ fontWeight: 700, color: "#7a0024" }}>+{newPhone}</Typography>
                </div>
              </div>
              <Typography variant="caption" color="textSecondary" style={{ display: "block", marginBottom: 20, lineHeight: 1.6 }}>Both numbers will be verified via OTP. You'll need access to your registered number to proceed.</Typography>
              <Button variant="contained" fullWidth style={{ background: "#7a0024", color: "#fff", height: 44, fontSize: 14, borderRadius: 8, marginBottom: 8 }} onClick={handleConfirmChange}>Yes, Change My Number →</Button>
              <Button variant="outlined" fullWidth style={{ color: "#7a0024", borderColor: "#f0dde3", height: 44, fontSize: 14, borderRadius: 8 }} onClick={onClose}>No, Cancel</Button>
            </div>
          </DialogContent>
        </>
      )}
      {step === 1 && (
        <>
          <DialogTitle style={{ borderBottom: "1px solid #f0f0f0", paddingBottom: 4 }}><span style={{ fontSize: 16, fontWeight: 600 }}>Verify Your Current Number</span><StepIndicator /></DialogTitle>
          <BlockUi tag="div" blocking={loader} message="Please wait...">
            <DialogContent style={{ padding: "1.5rem" }} className="pum-inner">
              <div style={{ textAlign: "center", marginBottom: 16 }}>
                <div style={{ fontSize: 40, marginBottom: 8 }}>📱</div>
                <Typography variant="body2" color="textSecondary" style={{ lineHeight: 1.6 }}>Enter your registered phone number to receive a verification OTP.</Typography>
              </div>
              {!oldOtpSent && (
                <>
                  <div style={{ marginBottom: 20 }}>
                    <Typography variant="caption" style={{ display: "block", marginBottom: 6, fontWeight: 600, color: "#444" }}>Your Registered Phone Number *</Typography>
                    <PhoneInput country={"in"} value={typedOldPhone} onChange={(phone) => setTypedOldPhone(phone)} countryCodeEditable={false} placeholder="Enter your registered number" inputProps={{ name: "oldPhone", autoFocus: true }} containerClass="input-dark" />
                    <Typography variant="caption" style={{ color: "#888", marginTop: 4, display: "block" }}>Hint: your number ends with <strong>...{existingUser?.mobileNumber?.slice(-2)}</strong></Typography>
                  </div>
                  <Button variant="contained" fullWidth style={{ background: "#7a0024", color: "#fff", height: 44, fontSize: 14, borderRadius: 8 }} onClick={handleSendOtpToRegistered}>Verify &amp; Send OTP →</Button>
                </>
              )}
              {oldOtpSent && (
                <>
                  <div style={{ background: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: 8, padding: "10px 14px", marginBottom: 20, display: "flex", alignItems: "center", gap: 8, fontSize: 13, color: "#15803d" }}><span>✓</span><span>OTP sent to <strong>+{typedOldPhone}</strong></span></div>
                  <Typography variant="caption" color="textSecondary" style={{ display: "block", marginBottom: 10, textAlign: "center" }}>Enter the 6-digit OTP</Typography>
                  <div style={{ display: "flex", justifyContent: "center", marginBottom: 20 }}><OtpInput length={6} onOtpSubmit={setOldOtp} /></div>
                  <Button variant="contained" fullWidth style={{ background: "#7a0024", color: "#fff", height: 44, fontSize: 14, borderRadius: 8, marginBottom: 10 }} onClick={verifyOldOtpAndProceed}>Verify OTP &amp; Continue →</Button>
                  <Typography variant="caption" style={{ color: "#7a0024", cursor: "pointer", display: "block", textAlign: "center" }} onClick={() => sendOtpToPhone(typedOldPhone, (id) => { setOldOtpId(id); toast.success("OTP resent"); })}>Didn't receive it? Resend OTP</Typography>
                </>
              )}
            </DialogContent>
          </BlockUi>
          <DialogActions style={{ padding: "8px 16px", borderTop: "1px solid #f0f0f0" }}><Button onClick={onClose} style={{ color: "#7a0024" }}>Cancel</Button></DialogActions>
        </>
      )}
      {step === 2 && (
        <>
          <DialogTitle style={{ borderBottom: "1px solid #f0f0f0", paddingBottom: 4 }}><span style={{ fontSize: 16, fontWeight: 600 }}>Verify Your New Number</span><StepIndicator /></DialogTitle>
          <BlockUi tag="div" blocking={loader} message="Please wait...">
            <DialogContent style={{ padding: "1.5rem" }} className="pum-inner">
              <div style={{ textAlign: "center" }}>
                <div style={{ fontSize: 40, marginBottom: 12 }}>✉️</div>
                <div style={{ background: "#f8f9fa", border: "1px solid #e9ecef", borderRadius: 10, padding: "12px 16px", marginBottom: 20, display: "flex", alignItems: "center", justifyContent: "center", gap: 10 }}>
                  <Typography variant="body2" style={{ color: "#9ca3af", textDecoration: "line-through" }}>+{typedOldPhone}</Typography>
                  <span style={{ color: "#9ca3af", fontSize: 18 }}>→</span>
                  <Typography variant="body2" style={{ color: "#7a0024", fontWeight: 700 }}>+{typedNewPhone}</Typography>
                </div>
                <Typography variant="body2" color="textSecondary" style={{ marginBottom: 6 }}>Enter the OTP sent to your new number</Typography>
                <Typography variant="body1" style={{ fontWeight: 700, color: "#7a0024", marginBottom: 20 }}>+{typedNewPhone}</Typography>
                <div style={{ display: "flex", justifyContent: "center", marginBottom: 20 }}><OtpInput length={6} onOtpSubmit={setNewOtp} /></div>
                <Button variant="contained" fullWidth style={{ background: "#7a0024", color: "#fff", height: 44, fontSize: 14, borderRadius: 8, marginBottom: 10 }} onClick={verifyNewOtpAndUpdate}>Verify &amp; Update Number →</Button>
                <Typography variant="caption" style={{ color: "#7a0024", cursor: "pointer" }} onClick={() => sendOtpToPhone(typedNewPhone, (id) => { setNewOtpId(id); toast.success("OTP resent to new number"); })}>Didn't receive it? Resend OTP</Typography>
              </div>
            </DialogContent>
          </BlockUi>
          <DialogActions style={{ padding: "8px 16px", borderTop: "1px solid #f0f0f0" }}><Button onClick={onClose} style={{ color: "#7a0024" }}>Cancel</Button></DialogActions>
        </>
      )}
      {step === 3 && (
        <>
          <DialogTitle style={{ borderBottom: "1px solid #f0f0f0" }}><span style={{ fontSize: 16, fontWeight: 600 }}>Phone Number Updated!</span></DialogTitle>
          <DialogContent style={{ padding: "1.5rem" }}>
            <div style={{ textAlign: "center" }}>
              <div style={{ fontSize: 56, marginBottom: 16 }}>✅</div>
              <Typography variant="body1" style={{ fontWeight: 600, marginBottom: 8, color: "#222" }}>Your number has been successfully updated!</Typography>
              <Typography variant="body2" color="textSecondary" style={{ marginBottom: 24, lineHeight: 1.6 }}>Your account is now linked to the new number and secured in our system.</Typography>
              <div style={{ background: "#f8f9fa", border: "1px solid #e9ecef", borderRadius: 12, padding: "16px 20px", marginBottom: 24, textAlign: "left" }}>
                <Typography variant="caption" style={{ display: "block", marginBottom: 12, fontWeight: 700, textTransform: "uppercase", letterSpacing: 1, color: "#6b7280" }}>Update Receipt</Typography>
                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 10 }}>
                  <Typography variant="caption" color="textSecondary">Previous Number</Typography>
                  <Typography variant="body2" style={{ textDecoration: "line-through", color: "#9ca3af", fontWeight: 500 }}>+{typedOldPhone}</Typography>
                </div>
                <div style={{ borderTop: "1px dashed #e5e7eb", margin: "8px 0" }} />
                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 10 }}>
                  <Typography variant="caption" color="textSecondary">New Number</Typography>
                  <Typography variant="body2" style={{ color: "#7a0024", fontWeight: 700 }}>+{typedNewPhone}</Typography>
                </div>
                <div style={{ borderTop: "1px dashed #e5e7eb", margin: "8px 0" }} />
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  <Typography variant="caption" color="textSecondary">Status</Typography>
                  <Typography variant="caption" style={{ color: "#15803d", fontWeight: 700, background: "#f0fdf4", padding: "2px 8px", borderRadius: 10, border: "1px solid #bbf7d0" }}>✓ Updated &amp; Verified</Typography>
                </div>
              </div>
              <Button variant="contained" fullWidth style={{ background: "#7a0024", color: "#fff", height: 44, fontSize: 14, borderRadius: 8 }} onClick={() => { onClose(); onSuccess(typedNewPhone); }}>Continue to Payment →</Button>
            </div>
          </DialogContent>
        </>
      )}
    </Dialog>
  );
}

const DEFAULT_LANGUAGE = [{ label: "English", value: 3, language: "ENGLISH", id: 3 }];
const DEFAULT_CATEGORY = [{ label: "General", value: 1, pId: 1 }];
const DEFAULT_ABOUT = "Service provider on Yuukke";
const DEFAULT_SERVICE_NAME = "My Service";

function RegistrationForm({ subscriptionList, languagelist, categoryList, onForceLogin, scrollToForm }) {
  const recaptcha = useRef();
  const [state, setState] = useState({
    userName: "", email: "", phoneNumber: "", otp: "", otpId: null, directoryId: null,
    loader: false, activeMenu: 0, subscriptionId: null, paymentAmount: "", initId: null,
    isAnnual: true, userId: null, try: 0, expandedPlanId: null,
  });
  const [extUsr, setExtUsr] = useState({});
  const [showExtUsr, setShowExtUsr] = useState(false);
  const [showPhoneUpdate, setShowPhoneUpdate] = useState(false);
  const [phoneUpdateUser, setPhoneUpdateUser] = useState(null);
  
  const [autoRenew, setAutoRenew] = useState(true); 

  const updateState = (name, value) => setState((prev) => ({ ...prev, [name]: value }));
  const loginYuukke = () => window.open(BASE_URL, "_blank");
  const openPaymentPage = (prize, id) => setState((prev) => ({ ...prev, paymentAmount: prize, subscriptionId: id }));

  const updatePaymentStatus = (status, id) => {
    if (status === "dismiss") {
      Swal.fire({ icon: "error", title: "Payment updating failed!", text: "If your money was debited, please contact our team at +91 04446314646", showConfirmButton: true })
        .then(() => setState((prev) => ({ ...prev, paymentAmount: null, subscriptionId: null, loader: false })));
    } else {
      updateState("loader", true);
      updateDetails(id);
    }
  };

  const sendOtp = (e, menu, skipConfirm = false) => {
    if (state.try === 4) { toast.warning("You tried maximum times, please try later!"); return; }
    if (state.phoneNumber.length < 6) { toast.warning("Enter valid phone number"); return; }
    const doSend = () => {
      updateState("loader", true);
      ProfileService.sendOtp({ type: "phone", phoneNumber: state.phoneNumber, optModelName: "Service" })
        .then((response) => {
          if (response.data.data?.id) {
            setState((prev) => ({ ...prev, otpId: response.data.data.id, loader: false, activeMenu: menu + 1, try: prev.try + 1 }));
            setTimeout(scrollToForm, 100); 
          } else updateState("loader", false);
        })
        .catch(() => { toast.error("Something went wrong"); updateState("loader", false); });
    };
    if (skipConfirm) { doSend(); return; }
    Swal.fire({
      icon: "question", title: "Confirm Your Number",
      html: `<div style="font-size:0.95rem;color:#444;line-height:1.6;">We'll send an OTP to<br/><strong style="font-size:1.1rem;color:#7a0024;">+${state.phoneNumber}</strong><br/><br/><span style="font-size:0.85rem;color:#888;">Did you type this correctly? You won't be able to change it after verification.</span></div>`,
      confirmButtonText: "Yes, Send OTP →", confirmButtonColor: "#7a0024", cancelButtonText: "No, Let Me Fix It", showCancelButton: true, reverseButtons: true,
    }).then((result) => { if (result.isConfirmed) doSend(); });
  };

  const saveInitDetails = (e, menu) => {
    const resolvedCategory = categoryList && categoryList.length > 0 ? [{ label: categoryList[0].label, value: categoryList[0].value, pId: categoryList[0].pId || 1 }] : DEFAULT_CATEGORY;
    const resolvedLanguage = languagelist && languagelist.length > 0 ? [{ label: languagelist[0].label, value: languagelist[0].value }] : DEFAULT_LANGUAGE;
    const formData = new FormData();
    formData.append("userName", state.userName.trim());
    formData.append("email", state.email?.trim());
    formData.append("phoneNumber", state.phoneNumber?.trim());
    formData.append("serviceName", DEFAULT_SERVICE_NAME);
    formData.append("description", DEFAULT_ABOUT);
    formData.append("businessName", state.userName.trim());
    formData.append("language", JSON.stringify({ data: resolvedLanguage.map((item) => ({ language: item.label, id: item.value })) }));
    formData.append("categoryV2", JSON.stringify({ data: resolvedCategory.map((item) => ({ primaryId: item.pId, categoryId: item.value })) }));
    if (state.directoryId) formData.append("directoryId", state.directoryId);

    const config = { headers: { "content-type": "multipart/form-data" } };
    updateState("loader", true);

    ProfileService.directoryAndServiceRegisterInit(formData, config)
      .then((response) => {
        const { status, data } = response.data;
        if (status === 2) {
          setState((prev) => ({ ...prev, email: data.email, userName: data.displayName, userId: data.userId, phoneNumber: data.mobileNumber, loader: false }));
          sendOtp(e, menu, true);
          return;
        }
        if (status === 3 || status === 6) {
          setExtUsr(data);
          setState((prev) => ({ ...prev, email: data.email, userName: data.displayName, userId: data.userId, phoneNumber: data.mobileNumber, loader: false }));
          setShowExtUsr(true);
          return;
        }
        if (status === 4) {
          updateState("loader", false);
          let seconds = 3;
          Swal.fire({
            icon: "info", title: "You Already Have an Account",
            html: `<div style="font-size:0.95rem;color:#444;">You're already registered with<br/><strong>${data.email}</strong><br/><br/>Redirecting to login in <strong id="swal-countdown">${seconds}</strong> second(s)...</div>`,
            showConfirmButton: false, showCancelButton: false, allowOutsideClick: false, allowEscapeKey: false,
            didOpen: () => {
              const interval = setInterval(() => {
                seconds -= 1;
                const el = document.getElementById("swal-countdown");
                if (el) el.textContent = seconds;
                if (seconds <= 0) { clearInterval(interval); Swal.close(); onForceLogin(data.email); }
              }, 1000);
            },
          });
          return;
        }
        if (status === 5) { updateState("loader", false); setPhoneUpdateUser(data); setShowPhoneUpdate(true); return; }
        if (status === 1 && response.data?.data?.id) { updateState("initId", response.data.data.id); sendOtp(e, menu); }
      })
      .catch(() => { toast.error("Something went wrong"); updateState("loader", false); });
  };

  const verifyOtp = () => {
    if (state.otp.length !== 6) { toast.warning("Enter valid OTP"); return; }
    updateState("loader", true);
    ProfileService.validateUserOtp({ otp: state.otp, id: state.otpId })
      .then((response) => {
        if (response.data.data === "VALID_OTP") {
          setState((prev) => ({ ...prev, activeMenu: prev.activeMenu + 1, loader: false }));
          setTimeout(scrollToForm, 100); 
        } else { 
          toast.error("Wrong OTP"); updateState("loader", false); 
        }
      })
      .catch(() => { toast.error("Something went wrong"); updateState("loader", false); });
  };

  const updateDetails = (paymentId) => {
    const resolvedCategory = categoryList && categoryList.length > 0 ? [{ label: categoryList[0].label, value: categoryList[0].value, pId: categoryList[0].pId || 1 }] : DEFAULT_CATEGORY;
    const resolvedLanguage = languagelist && languagelist.length > 0 ? [{ label: languagelist[0].label, value: languagelist[0].value }] : DEFAULT_LANGUAGE;
    const formData = new FormData();
    formData.append("firstName", state.userName.trim());
    formData.append("lastName", state.userName.trim().substring(0, 1));
    formData.append("email", state.email);
    formData.append("phoneNumber", state.phoneNumber);
    formData.append("serviceName", DEFAULT_SERVICE_NAME);
    formData.append("description", DEFAULT_ABOUT);
    formData.append("businessName", state.userName.trim());
    formData.append("language", JSON.stringify({ data: resolvedLanguage.map((item) => ({ language: item.label, id: item.value })) }));
    formData.append("categoryV2", JSON.stringify({ data: resolvedCategory.map((item) => ({ primaryId: item.pId, categoryId: item.value })) }));
    formData.append("categoryId", resolvedCategory[0]?.value);
    formData.append("categoryName", resolvedCategory[0]?.label);
    if (state.directoryId) formData.append("directoryId", state.directoryId);
    formData.append("subscriptionId", state.subscriptionId);
    formData.append("paymentId", paymentId);
    if (state.initId) formData.append("initId", state.initId);

    const config = { headers: { "content-type": "multipart/form-data" } };
    ProfileService.directoryAndServiceRegister(formData, config)
      .then((response) => {
        if (response.data.status !== 1) {
          toast.error("Something went wrong, please try again later");
          setState((prev) => ({ ...prev, otpId: null, loader: false, otp: "", subscriptionId: null }));
        } else {
          setState((prev) => ({ ...prev, otpId: null, loader: false, otp: "", activeMenu: prev.activeMenu + 1, subscriptionId: null }));
          setTimeout(scrollToForm, 100); 
        }
      })
      .catch(() => {
        toast.error("Something went wrong, please try again later");
        setState((prev) => ({ ...prev, otpId: null, loader: false, otp: "" }));
      });
  };

  const changeScreen = (e, menu) => {
    e.preventDefault(); e.stopPropagation();
    const captchaValue = recaptcha?.current?.getValue();
    if (!captchaValue) { toast.warning("Please verify the reCAPTCHA!"); return; }
    if (menu === 0) saveInitDetails(e, menu);
    else {
      updateState("activeMenu", menu + 1);
      setTimeout(scrollToForm, 100); 
    }
  };

  const onContinueWithExtUsr = () => {
    setShowExtUsr(false);
    setState((prev) => ({ ...prev, phoneNumber: extUsr.mobileNumber, email: extUsr.email, userName: extUsr.displayName, activeMenu: 2 }));
    setTimeout(scrollToForm, 100); 
  };

  const sortedSubscriptions = [...(subscriptionList || [])].sort((a, b) => a.prize - b.prize);
  const selectedPlan = subscriptionList?.find((s) => s.id === state.subscriptionId);
  const isFreeTrialSelected = selectedPlan?.subscribeType === "FREE_TRIAL";

  const startFreeTrial = async () => {
    if (!state.subscriptionId) {
      toast.warning("Please select the Free Trial plan first");
      return;
    }

    updateState("loader", true);
    const freeOrderId = `Free_${state.initId || state.userId || Date.now()}`;
    let paymentRowId = null;

    try {
      const paymentPayload = {
        paymentId: freeOrderId,
        orderId: freeOrderId,
        razorpaySignature: `FREE_${freeOrderId}`,
        amount: 0,
        realAmount: 0,
        razorpayAmount: 0,
        type: "Service-Register",
        subscriptionId: state.subscriptionId,
        email: state.email,
        name: state.userName,
        serviceId: null,
        status: "success",
      };
      if (state.userId) paymentPayload.userId = state.userId;

      const apiCall = state.userId
        ? MyYuukke.savePaymentInforMation(paymentPayload)
        : MyYuukke.savePaymentInforMationWithoutAuth(paymentPayload);

      const payRes = await apiCall;
      paymentRowId = payRes?.data?.data?.id;
    } catch (err) {
      console.error("❌ Free trial payment record failed:", err?.response?.data || err.message || err);
    }

    if (!paymentRowId) {
      toast.error("Couldn't record your free trial. Please try again.");
      updateState("loader", false);
      return;
    }

    try {
      await updateDetailsAsync(paymentRowId);
    } catch (err) {
      console.error("❌ Free trial registration failed:", err?.response?.data || err.message || err);
      toast.error("Something went wrong completing your free trial. Please try again.");
      updateState("loader", false);
    }
  };

  const updateDetailsAsync = (paymentId) => {
    const resolvedCategory = categoryList && categoryList.length > 0 ? [{ label: categoryList[0].label, value: categoryList[0].value, pId: categoryList[0].pId || 1 }] : DEFAULT_CATEGORY;
    const resolvedLanguage = languagelist && languagelist.length > 0 ? [{ label: languagelist[0].label, value: languagelist[0].value }] : DEFAULT_LANGUAGE;
    const formData = new FormData();
    formData.append("firstName", state.userName.trim());
    formData.append("lastName", state.userName.trim().substring(0, 1));
    formData.append("email", state.email);
    formData.append("phoneNumber", state.phoneNumber);
    formData.append("serviceName", DEFAULT_SERVICE_NAME);
    formData.append("description", DEFAULT_ABOUT);
    formData.append("businessName", state.userName.trim());
    formData.append("language", JSON.stringify({ data: resolvedLanguage.map((item) => ({ language: item.label, id: item.value })) }));
    formData.append("categoryV2", JSON.stringify({ data: resolvedCategory.map((item) => ({ primaryId: item.pId, categoryId: item.value })) }));
    formData.append("categoryId", resolvedCategory[0]?.value);
    formData.append("categoryName", resolvedCategory[0]?.label);
    if (state.directoryId) formData.append("directoryId", state.directoryId);
    formData.append("subscriptionId", state.subscriptionId);
    formData.append("paymentId", paymentId);
    if (state.initId) formData.append("initId", state.initId);

    const config = { headers: { "content-type": "multipart/form-data" } };
    return ProfileService.directoryAndServiceRegister(formData, config).then((response) => {
      if (response.data.status !== 1) {
        toast.error(response.data.message || "Something went wrong, please try again later");
        setState((prev) => ({ ...prev, otpId: null, loader: false, otp: "", subscriptionId: null }));
        throw new Error(response.data.message || "Registration failed with status " + response.data.status);
      }
      setState((prev) => ({ ...prev, otpId: null, loader: false, otp: "", activeMenu: prev.activeMenu + 1, subscriptionId: null }));
      setTimeout(scrollToForm, 100); 
      return response;
    });
  };

  return (
    <>
      <BlockUi tag="div" message="Loading, please wait" style={{ minHeight: "100%" }} className="wallLoadingPage pb-3" blocking={state.loader}>
        {state.activeMenu === 0 && (
          <>
            <h2 className="yk2-form-title">Let's get started 🚀</h2>
            <p className="yk2-form-subtitle">Join 500+ women entrepreneurs. Set up your profile in minutes.</p>
            <FormStepBar active={0} total={4} />
            <form onSubmit={(e) => changeScreen(e, 0)}>
              <div className="yk2-field-group">
                <div className="yk2-field">
                  <label>What's Your Name? *</label>
                  <input type="text" placeholder="Kavitha Menon" value={state.userName} onChange={(e) => updateState("userName", e.target.value)} required />
                </div>
                <div className="yk2-field">
                  <label>Where Can We Reach You By Email? *</label>
                  <input type="email" placeholder="kavitha@example.com" value={state.email} onChange={(e) => updateState("email", e.target.value)} required />
                </div>
                <div className="yk2-field">
                  <label>And Your Phone Number? *</label>
                  <div style={{ marginTop: "4px" }}>
                    <PhoneInput country={"in"} containerClass="input-dark" value={state.phoneNumber} placeholder="" countryCodeEditable={false} onChange={(phone) => updateState("phoneNumber", phone)} required />
                  </div>
                  <span className="yk2-field-hint">We'll send your OTP to this number</span>
                </div>
              </div>
              <div style={{ background: "#fff9f7", border: "1px solid #f0dde3", borderRadius: 10, padding: "0.85rem 1rem", fontSize: "0.85rem", color: "#6b4550", marginBottom: "1.25rem", lineHeight: 1.65 }}>
                ✏️ You can update your <strong>business name, category, language, and service details</strong> anytime from your profile after signing up.
              </div>
              <div style={{ marginTop: "1rem", marginBottom: "1rem", minHeight: "78px", display: "flex", justifyContent: "center" }}>
                <ReCAPTCHA ref={recaptcha} sitekey={REACT_APP_SITE_KEY} theme="light" size="normal" />
              </div>
              <button type="submit" className="yk2-form-submit yk2-rpl" onClick={ripple}>Get OTP →</button>
              <p className="yk2-form-privacy">🔒 Your data is encrypted and never shared.</p>
            </form>
          </>
        )}

        {state.activeMenu === 1 && (
          <div className="card p-3 m-auto" style={{ maxWidth: "30rem", textAlign: "start", boxShadow: "none" }}>
            <h2 className="yk2-form-title">Verify Your Number</h2>
            <p className="yk2-form-subtitle">OTP sent to <strong>+{state.phoneNumber?.slice(2)}</strong>. Enter the 6-digit code below.</p>
            <FormStepBar active={1} total={4} />
            <Card className="profileCard align-items-center" style={{ border: "none" }}>
              <p style={{ fontSize: "12px" }} className="text-secondary mt-3 text-center">Please enter your OTP!</p>
              <div className="p-3 d-flex g-1 align-items-center justify-content-center service-otp">
                <OtpInput length={6} onOtpSubmit={(otp) => updateState("otp", otp)} />
              </div>
              <button className="yk2-form-submit yk2-rpl mt-3 mb-3" style={{ width: "fit-content", padding: ".75rem 2rem" }} onClick={(e) => { ripple(e); verifyOtp(); }}>Verify OTP →</button>
            </Card>
            <p className="yk2-form-privacy" style={{ marginTop: ".75rem" }}>
              Didn't receive it? <span style={{ color: "#a00030", cursor: "pointer", fontWeight: 600 }} onClick={() => sendOtp(null, 0, true)}>Resend OTP</span>
            </p>
          </div>
        )}

        {state.activeMenu === 2 && (
          <div>
            <header style={{textAlign: "center", marginBottom: "1.5rem"}}>
                <h2 className="yk2-form-title">Choose Your Plan</h2>
                <p className="yk2-form-subtitle">Start free, upgrade anytime — or lock in lifetime access.</p>
                <FormStepBar active={2} total={4} />
            </header>

            <div className="yk2-sub-cards" role="list">
              {sortedSubscriptions.map((data) => {
                const meta = getPlanMeta(data);
                const isFree = data.subscribeType === "FREE_TRIAL";
                const isSelected = state.subscriptionId === data.id;

                return (
                  <article
                    key={data.id}
                    role="listitem"
                    className={`yk2-sub-card${isSelected ? " selected" : ""}`}
                    onClick={() => isFree ? updateState("subscriptionId", data.id) : openPaymentPage(data.prize, data.id)}
                    onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          isFree ? updateState("subscriptionId", data.id) : openPaymentPage(data.prize, data.id);
                        }
                    }}
                    tabIndex={0}
                  >
                    {meta.badge && (
                      <span className="yk2-sub-badge" style={{ backgroundColor: meta.badgeColor }}>
                        {meta.badge}
                      </span>
                    )}
                    <header className="yk2-sub-header">
                        <h3 className="yk2-sub-card-name">{data.subscriptionName}</h3>
                        {meta.duration && <div className="yk2-sub-duration">{meta.duration}</div>}
                        {meta.billing && <div className="yk2-sub-billing">{meta.billing}</div>}
                    </header>
                    <div className="yk2-sub-card-pricing">
                        {isFree ? (
                          <div className="yk2-sub-price" style={{ color: "#2563eb" }}>Free</div>
                        ) : (
                          <>
                            <div className="yk2-sub-price">₹{data.prize.toLocaleString("en-IN")}</div>
                            <div className="yk2-sub-price-suffix">{meta.priceSuffix}</div>
                          </>
                        )}
                    </div>
                    <div
                        className="yk2-sub-card-desc"
                        dangerouslySetInnerHTML={{ __html: data.subscribeDescription.replace(/<p><\/p>/g, "<br/>") }}
                    />
                    <footer className="yk2-sub-card-footer">
                        {isSelected ? (
                            isFree ? (
                              <button
                                type="button"
                                className="yk2-sub-status-selected"
                                style={{ border: "none", cursor: "pointer", width: "100%", background: "transparent", font: "inherit" }}
                                onClick={(e) => { e.stopPropagation(); ripple(e); startFreeTrial(); }}
                              >
                                ✓ Selected — Tap to Start Free Trial →
                              </button>
                            ) : (
                              <div className="yk2-sub-status-selected">✓ Selected — Review details below</div>
                            )
                        ) : (
                            <div className="yk2-sub-status-unselected">Select Plan →</div>
                        )}
                    </footer>
                  </article>
                );
              })}
            </div>

            {/* --- EXPLICIT UI FOR LIFETIME VS RECURRING BASED ON RAZORPAY PLAN ID --- */}
            {selectedPlan && !isFreeTrialSelected && (
              <div style={{ background: !selectedPlan.razorpayPlanId ? "#f0fdf4" : "#fff8f9", border: !selectedPlan.razorpayPlanId ? "1px solid #bbf7d0" : "1px solid #f0dde3", padding: "15px", borderRadius: "10px", marginTop: "20px", marginBottom: "20px" }}>
                <h4 style={{ fontSize: "16px", color: !selectedPlan.razorpayPlanId ? "#15803d" : "#7a0024", marginBottom: "10px", fontWeight: "bold" }}>
                  Payment Details for {selectedPlan.subscriptionName}
                </h4>
                
                {!selectedPlan.razorpayPlanId ? (
                  <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <span style={{ fontSize: "24px" }}>🎉</span>
                    <div style={{ display: "flex", flexDirection: "column", textAlign: "left" }}>
                      <span style={{ fontSize: "0.95rem", color: "#15803d", fontWeight: 600 }}>
                        Pay once. Access confirmed.
                      </span>
                      <span style={{ fontSize: "0.8rem", color: "#166534", marginTop: "2px" }}>
                        This is a one-time payment. There are no automatic renewals or hidden charges for this plan.
                      </span>
                    </div>
                  </div>
                ) : (
                  <label style={{ display: "flex", alignItems: "center", gap: "12px", cursor: "pointer", background: autoRenew ? "#ffeef3" : "#fff", padding: "12px 15px", borderRadius: "8px", border: autoRenew ? "1px solid #7a0024" : "1px solid #e5e7eb", transition: "all 0.2s" }}>
                    <input 
                      type="checkbox" 
                      checked={autoRenew} 
                      onChange={(e) => setAutoRenew(e.target.checked)} 
                      style={{ width: "20px", height: "20px", accentColor: "#7a0024", cursor: "pointer" }} 
                    />
                    <div style={{ display: "flex", flexDirection: "column", textAlign: "left" }}>
                      <span style={{ fontSize: "0.95rem", color: autoRenew ? "#7a0024" : "#4b5563", fontWeight: 600 }}>
                        Enable Auto-Renewal (Recommended)
                      </span>
                      <span style={{ fontSize: "0.8rem", color: "#6b7280", marginTop: "2px" }}>
                        We will automatically bill you when this plan expires so your service is never interrupted. Uncheck to pay manually next time.
                      </span>
                    </div>
                  </label>
                )}
              </div>
            )}

            {/* --- RAZORPAY COMPONENT --- */}
            {state.subscriptionId && !isFreeTrialSelected && (
              <RazorPay
                email={state.email} name={state.userName} userId={null} contactNumber={state.phoneNumber}
                subscriptionId={state.subscriptionId} amount={state.paymentAmount} type={"Service-Register"}
                updatePaymentStatus={updatePaymentStatus} initId={state.initId} uId={state.userId}
                selectedPlan={selectedPlan}
                autoRenew={autoRenew}
              />
            )}

            <p className="yk2-form-privacy" style={{textAlign: "center", marginTop: "1rem"}}>
              🔒 Secured via Razorpay · UPI · Cards · Net Banking
            </p>

          </div>
        )}

        {state.activeMenu === 3 && (
          <div style={{ padding: "2rem 1.75rem 2.25rem", background: "#fff" }}>
            <div style={{ display: "flex", alignItems: "center", marginBottom: "2.25rem" }}>
              {[{ icon: "👤", label: "Details" }, { icon: "📱", label: "Verify" }, { icon: "💳", label: "Payment" }, { icon: "✓", label: "Done" }].map((s, i) => (
                <React.Fragment key={i}>
                  <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 5, flex: 1 }}>
                    <div style={{ width: 32, height: 32, borderRadius: "50%", background: "#7a0024", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 14, color: "#fff", animation: `yk2-pop 0.4s cubic-bezier(0.34,1.56,0.64,1) ${i * 0.12}s both` }}>{s.icon}</div>
                    <span style={{ fontSize: 11, color: "#7a0024", fontWeight: 500 }}>{s.label}</span>
                  </div>
                  {i < 3 && <div style={{ flex: 1, height: 1.5, background: "#f0dde3", marginBottom: 16, animation: `yk2-grow 0.5s ease ${i * 0.12 + 0.05}s both`, transformOrigin: "left" }} />}
                </React.Fragment>
              ))}
            </div>
            <div style={{ border: "0.5px solid #f0dde3", borderRadius: 16, padding: "2rem 1.75rem 1.75rem", display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center", animation: "yk2-scale 0.45s ease 0.3s both" }}>
              <div style={{ position: "relative", width: 64, height: 64, marginBottom: "1.25rem" }}>
                <div style={{ width: 64, height: 64, borderRadius: "50%", border: "1.5px solid #f0dde3", background: "#fff8f9", display: "flex", alignItems: "center", justifyContent: "center" }}><span style={{ fontSize: 28 }}>🏅</span></div>
                <div style={{ position: "absolute", bottom: -2, right: -4, width: 22, height: 22, borderRadius: "50%", background: "#7a0024", border: "2px solid #fff", display: "flex", alignItems: "center", justifyContent: "center", animation: "yk2-pop 0.4s cubic-bezier(0.34,1.56,0.64,1) 0.65s both" }}><span style={{ fontSize: 11, color: "#fff" }}>✓</span></div>
              </div>
              <h3 style={{ fontSize: "1.25rem", fontWeight: 500, margin: "0 0 0.35rem", animation: "yk2-fadein 0.4s ease 0.45s both" }}>You're all set!</h3>
              <p style={{ fontSize: 13, color: "#6b4550", margin: "0 0 1.5rem", lineHeight: 1.65, maxWidth: 300, animation: "yk2-fadein 0.4s ease 0.5s both" }}>
                Welcome to Yuukke. We'll send your login details to <strong style={{ color: "#7a0024" }}>+{state.phoneNumber}</strong> on WhatsApp.
              </p>
              <div style={{ width: "100%", maxWidth: 320, marginBottom: "1.75rem", animation: "yk2-fadein 0.4s ease 0.55s both" }}>
                {["Profile created & live", "Payments & GST invoicing ready", "WhatsApp reminders activated"].map((text, i) => (
                  <div key={i} style={{ display: "flex", alignItems: "center", gap: 10, padding: "9px 12px", borderRadius: 10, marginBottom: 6, background: "#fff8f9", border: "0.5px solid #f0dde3" }}>
                    <div style={{ width: 24, height: 24, borderRadius: "50%", background: "#7a0024", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, animation: `yk2-pop 0.35s cubic-bezier(0.34,1.56,0.64,1) ${0.6 + i * 0.1}s both` }}><span style={{ fontSize: 11, color: "#fff" }}>✓</span></div>
                    <span style={{ fontSize: 13, color: "#7a0024", fontWeight: 500 }}>{text}</span>
                  </div>
                ))}
              </div>
              <hr style={{ width: "100%", maxWidth: 320, border: "none", borderTop: "0.5px solid #f0dde3", margin: "0 0 1.5rem" }} />
              <button className="yk2-rpl" style={{ width: "100%", maxWidth: 280, height: 46, borderRadius: 12, background: "#7a0024", color: "#fff", fontSize: 14, fontWeight: 500, border: "none", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", gap: 8, animation: "yk2-fadein 0.4s ease 0.75s both" }} onClick={(e) => { ripple(e); loginYuukke(); }}>
                Go to your dashboard →
              </button>
              <p style={{ marginTop: "0.9rem", fontSize: 12, color: "#9a7a82", animation: "yk2-fadein 0.4s ease 0.85s both" }}>Need help? <span style={{ color: "#7a0024", cursor: "pointer", fontWeight: 500 }} onClick={() => window.open("https://wa.me/919150625864", "_blank")}>Chat with us on WhatsApp</span></p>
            </div>
          </div>
        )}
      </BlockUi>

      <PhoneUpdateModal open={showPhoneUpdate} onClose={() => setShowPhoneUpdate(false)} existingUser={phoneUpdateUser} newPhone={state.phoneNumber} onSuccess={(verifiedNewPhone) => { setShowPhoneUpdate(false); setState((prev) => ({ ...prev, email: phoneUpdateUser.email, userName: phoneUpdateUser.displayName, userId: phoneUpdateUser.userId, phoneNumber: verifiedNewPhone, activeMenu: 2 })); setTimeout(scrollToForm, 100); }} />

      <Dialog open={showExtUsr} onClose={() => setShowExtUsr(false)} maxWidth="sm" fullWidth>
        <DialogTitle>User Already Exists</DialogTitle>
        <DialogContent>
          <Box display="flex" flexDirection="row" alignItems="center" p={2} style={{ border: "1px solid hsl(220 13% 91%)", borderRadius: "8px" }}>
            <Avatar src={`${API_URL}auth/image/${extUsr.profilePhoto}`} style={{ width: 80, height: 80, marginRight: 16 }} />
            <Box display="flex" flexDirection="column">
              <Typography variant="subtitle1">{extUsr.displayName || ""}</Typography>
              <Typography variant="body1">{extUsr.email || ""}</Typography>
              <Typography variant="body2" color="textSecondary">{extUsr.mobileNumber || ""}</Typography>
            </Box>
          </Box>
          <Typography variant="subtitle1" color="textSecondary" align="center" style={{ marginTop: 12 }}>You already have an account. Shall we continue with this account?</Typography>
          <Box display="flex" justifyContent="center" mt={1}>
            <Typography variant="caption" color="textSecondary" align="center">Note: Please use this existing account credentials for all future services. If you don't remember your credentials, use "Forgot Password" with this email: <strong>{extUsr.email}</strong></Typography>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowExtUsr(false)} color="secondary" variant="outlined" style={{ color: "brown", background: "transparent" }}>Cancel</Button>
          <Button onClick={onContinueWithExtUsr} color="primary" variant="contained">Continue</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// VIDEO PLAYER
// ─────────────────────────────────────────────────────────────────────────────
function VideoPlayer() {
  const [playing, setPlaying] = useState(false);
  const videoId = "d0F2JDIIoNQ";
  return (
    <div className="yk2-video-wrapper">
      {playing ? (
        <iframe src={`https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1&controls=1`} title="Yuukke overview" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
      ) : (
        <>
          <img src={`https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`} alt="Watch how Yuukke works" style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} onError={(e) => { e.target.src = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`; }} />
          <div className="yk2-video-overlay" onClick={() => setPlaying(true)}><div className="yk2-play-btn"><svg width="22" height="22" viewBox="0 0 24 24" fill="white"><path d="M8 5v14l11-7z" /></svg></div></div>
        </>
      )}
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// STATIC DATA
// ─────────────────────────────────────────────────────────────────────────────
const FEATURES = [
  { tab: "Branded Pages", title: "Your brand, your rules", desc: "Create a stunning landing page with your brand colors, logo, and bio. Share one link everywhere.", points: ["Custom themes and colors", "Multiple profiles per account", "Mobile-optimized", "SEO-ready"], visual: (<div style={{ width: "100%", textAlign: "center" }}><div style={{ background: "#fff", borderRadius: 12, padding: "1.5rem", border: "1px solid #f0dde3", marginBottom: ".75rem" }}><div style={{ width: 48, height: 48, borderRadius: "50%", background: "#a00030", margin: "0 auto .75rem", display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontWeight: 700, fontSize: "1.1rem" }}>YK</div><div style={{ fontWeight: 700, marginBottom: ".25rem" }}>Kavitha Menon</div><div style={{ fontSize: ".8rem", color: "#6b4550", marginBottom: "1rem" }}>Life Coach · Kochi</div><div style={{ display: "flex", gap: ".5rem", justifyContent: "center", flexWrap: "wrap" }}>{["1:1 Coaching", "Group Session", "Strategy Call"].map((s) => (<span key={s} style={{ background: "#fff9f7", border: "1px solid #f0dde3", borderRadius: 8, padding: ".3rem .6rem", fontSize: ".75rem", cursor: "pointer" }}>{s}</span>))}</div></div><div style={{ fontSize: ".8rem", color: "#6b4550" }}>yuukke.com/kavitha</div></div>) },
  { tab: "Smart Booking", title: "Bookings on autopilot", desc: "Let clients self-book without back-and-forth. Set your availability, block times, let the calendar do the work.", points: ["Availability management", "Auto-confirmations", "Buffer time between sessions", "Timezone detection"], visual: (<div style={{ width: "100%" }}><div style={{ display: "grid", gridTemplateColumns: "repeat(7,1fr)", gap: 4, marginBottom: ".75rem" }}>{["M", "T", "W", "T", "F", "S", "S"].map((d, i) => (<div key={i} style={{ textAlign: "center", fontSize: ".7rem", color: "#6b4550", fontWeight: 700 }}>{d}</div>))}{Array.from({ length: 31 }, (_, i) => i + 1).map((d) => (<div key={d} style={{ textAlign: "center", padding: "4px 2px", borderRadius: 6, fontSize: ".75rem", background: d === 15 ? "#a00030" : d === 18 || d === 22 ? "#ffeef3" : "transparent", color: d === 15 ? "#fff" : d === 18 || d === 22 ? "#a00030" : "inherit", fontWeight: d === 15 || d === 18 || d === 22 ? 700 : 400 }}>{d}</div>))}</div>{["10:00 AM", "11:00 AM", "2:00 PM"].map((t) => (<div key={t} style={{ background: "#ffeef3", borderRadius: 8, padding: ".5rem .75rem", fontSize: ".8rem", color: "#a00030", fontWeight: 600, marginBottom: 6 }}>{t} — Available</div>))}</div>) },
  { tab: "Video Sessions", title: "No third-party apps needed", desc: "Built-in HD video calls. No Zoom, no Meet, no extra subscriptions. Your clients join with one click.", points: ["HD video & audio", "Screen sharing", "Session recording", "One-click join for clients"], visual: (<div style={{ width: "100%", background: "#1a0a0f", borderRadius: 12, padding: "1.5rem", color: "#fff", textAlign: "center" }}><div style={{ display: "flex", gap: 12, justifyContent: "center", marginBottom: "1rem" }}>{["KM", "YK"].map((i) => (<div key={i} style={{ width: 64, height: 64, borderRadius: 12, background: "#a00030", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 700 }}>{i}</div>))}</div><div style={{ fontSize: ".85rem", color: "rgba(255,255,255,0.7)", marginBottom: "1rem" }}>Session in progress · 32:15</div><div style={{ display: "flex", gap: 12, justifyContent: "center" }}>{["🎤", "📹", "🖥️", "❌"].map((icon, i) => (<div key={i} style={{ width: 40, height: 40, borderRadius: "50%", background: i === 3 ? "#ef4444" : "rgba(255,255,255,0.15)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "1rem", cursor: "pointer" }}>{icon}</div>))}</div></div>) },
  { tab: "Payments", title: "India-first payments", desc: "Razorpay + UPI built in. Clients pay instantly, you get paid instantly. No commission.", points: ["UPI, cards, net banking", "Instant payouts", "Automated reminders", "Refund management"], visual: (<div style={{ width: "100%" }}><div style={{ background: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: 12, padding: "1rem", marginBottom: ".75rem", display: "flex", alignItems: "center", gap: ".75rem" }}><span style={{ fontSize: "1.5rem" }}>✅</span><div><div style={{ fontWeight: 700, color: "#15803d" }}>Payment Received</div><div style={{ fontSize: ".8rem", color: "#166534" }}>+₹2,500 · Razorpay</div></div></div>{[{ icon: "📱", label: "Pay via UPI" }, { icon: "💳", label: "Credit/Debit Card" }, { icon: "🏦", label: "Net Banking" }].map((p) => (<div key={p.label} style={{ display: "flex", alignItems: "center", gap: ".6rem", padding: ".6rem .75rem", borderRadius: 8, border: "1px solid #f0dde3", marginBottom: ".5rem", fontSize: ".85rem" }}><span>{p.icon}</span><span>{p.label}</span></div>))}</div>) },
  { tab: "Invoicing", title: "GST invoicing, automated", desc: "Auto-generate GST-compliant PDF invoices after every session. No more manual billing.", points: ["GST-compliant PDFs", "Auto-send after booking", "Invoice history", "HSN/SAC code support"], visual: (<div style={{ background: "#fff", border: "1px solid #f0dde3", borderRadius: 12, padding: "1.5rem", fontSize: ".8rem", width: "100%" }}><div style={{ display: "flex", justifyContent: "space-between", marginBottom: "1rem", fontWeight: 700 }}><span>TAX INVOICE</span><span style={{ color: "#a00030" }}>#INV-2026-047</span></div><div style={{ borderBottom: "1px solid #f0dde3", paddingBottom: ".75rem", marginBottom: ".75rem", color: "#6b4550" }}><div style={{ marginBottom: ".25rem" }}>Service: 1:1 Coaching Session</div><div>Date: 31 Mar 2026</div></div><div style={{ display: "flex", justifyContent: "space-between", marginBottom: ".3rem" }}><span>Sub-total</span><span>₹2,119</span></div><div style={{ display: "flex", justifyContent: "space-between", marginBottom: ".5rem", color: "#6b4550" }}><span>GST @18%</span><span>₹381</span></div><div style={{ display: "flex", justifyContent: "space-between", fontWeight: 700, color: "#a00030", paddingTop: ".5rem", borderTop: "1px solid #f0dde3" }}><span>Total</span><span>₹2,500</span></div></div>) },
  { tab: "Client CRM", title: "Know your clients deeply", desc: "Every booking, note, and message in one place. Build lasting client relationships.", points: ["Full booking history", "Notes per client", "WhatsApp reminders", "Client tags & segments"], visual: (<div style={{ width: "100%" }}>{[{ name: "Priya R.", sessions: 8, last: "28 Mar", tag: "Active" }, { name: "Meera S.", sessions: 3, last: "20 Mar", tag: "New" }, { name: "Divya K.", sessions: 12, last: "15 Mar", tag: "VIP" }].map((c) => (<div key={c.name} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: ".75rem .5rem", borderBottom: "1px solid #f0dde3" }}><div style={{ display: "flex", alignItems: "center", gap: ".6rem" }}><div style={{ width: 32, height: 32, borderRadius: "50%", background: "#a00030", color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", fontSize: ".75rem", fontWeight: 700 }}>{c.name[0]}</div><div><div style={{ fontWeight: 600, fontSize: ".875rem" }}>{c.name}</div><div style={{ fontSize: ".75rem", color: "#6b4550" }}>{c.sessions} sessions · Last {c.last}</div></div></div><span style={{ background: c.tag === "VIP" ? "#fef3c7" : c.tag === "New" ? "#eff6ff" : "#f0fdf4", color: c.tag === "VIP" ? "#92400e" : c.tag === "New" ? "#1d4ed8" : "#15803d", fontSize: ".75rem", fontWeight: 700, padding: ".2rem .6rem", borderRadius: 20 }}>{c.tag}</span></div>))}</div>) },
];
const TESTIMONIALS = [
  { quote: "I was managing clients on WhatsApp and tracking payments in a spreadsheet. Yuukke replaced 4 tools overnight. My clients love the booking page.", name: "Kavitha Menon", role: "Life Coach, Kochi", initials: "KM" },
  { quote: "The GST invoicing alone is worth it. I used to dread month-end billing. Now it auto-generates with one click. And the video calls are smooth.", name: "Priya Rajagopalan", role: "Yoga Instructor, Chennai", initials: "PR" },
  { quote: "As a consultant, I need different profiles for different services. Yuukke lets me run two brands from one account. The lifetime deal was a no-brainer.", name: "Ananya Desai", role: "Business Consultant, Mumbai", initials: "AD" },
];
const COMPARE = [
  { feature: "Online Booking", yuukke: "✅", calendly: "✅", honeybook: "✅", dubsado: "✅" },
  { feature: "Built-in Video Calls", yuukke: "✅", calendly: "❌", honeybook: "❌", dubsado: "❌" },
  { feature: "India Payments (UPI)", yuukke: "✅", calendly: "❌", honeybook: "Not in India", dubsado: "❌" },
  { feature: "GST Invoicing", yuukke: "✅", calendly: "❌", honeybook: "❌", dubsado: "❌" },
  { feature: "Client CRM", yuukke: "✅", calendly: "❌", honeybook: "✅", dubsado: "✅" },
  { feature: "WhatsApp Reminders", yuukke: "✅", calendly: "❌", honeybook: "❌", dubsado: "❌" },
  { feature: "Multiple Profiles", yuukke: "Free", calendly: "❌", honeybook: "❌", dubsado: "$10/mo extra" },
  { feature: "Pricing (India)", yuukke: "₹4,999 lifetime", calendly: "$10/mo", honeybook: "Not available", dubsado: "$20/mo" },
];
const FAQS = [
  { q: "What is Yuukke?", a: "Yuukke is an all-in-one platform for women coaches, consultants, and service providers in India. It combines booking, payments, video calls, invoicing, and CRM in one place." },
  { q: "Is it really a lifetime deal?", a: "Yes! Pay ₹4,999 once and use Yuukke forever — no monthly fees, no hidden charges. This offer is limited to the first 5,000 women service providers." },
  { q: "What payment methods do my clients get?", a: "Your clients can pay via UPI, credit/debit cards, and net banking — all powered by Razorpay, India's leading payment gateway." },
  { q: "Do I need any technical skills?", a: "Absolutely not. Yuukke is built for non-technical users. Set up your profile and start taking bookings in under 5 minutes." },
  { q: "Can I have multiple profiles or brands?", a: "Yes! You can run multiple service profiles from a single Yuukke account — great for consultants with different verticals." },
  { q: "How do video calls work?", a: "Video calls are built directly into Yuukke. No Zoom or Google Meet needed. Clients join with a single click from their booking confirmation email." },
  { q: "Can I send GST-compliant invoices?", a: "Yes. Yuukke auto-generates GST-compliant PDF invoices after every session and emails them to your clients automatically." },
  { q: "What about WhatsApp reminders?", a: "Yuukke sends automated WhatsApp reminders to both you and your clients before sessions, reducing no-shows significantly." },
];
const STEP_INFO = [
  { icon: "👤", title: "Your Details", sub: "Provide your details and services" },
  { icon: "✉️", title: "Verify your OTP", sub: "Enter your verification code" },
  { icon: "💳", title: "Payment", sub: "Complete your payment securely" },
  { icon: "🎉", title: "Welcome to Yuukke", sub: "Let's get started" },
];

const PRICING_CONTENT = {
  free: {
    badge: "TRY FREE",
    orig: "",
    main: "0",
    suffix: "for 7 days",
    title: "Try before you commit.",
    sub: "Full access to explore our platform.",
    subText: "No credit card required to start",
    features: ["Full platform access", "Ad postings & connections", "Meeting scheduling", "Community participation", "Cancel anytime"],
    cta: "Start Free Trial"
  },
  yearly: {
    badge: "MOST FLEXIBLE",
    orig: "Rs. 3,000/year",
    main: "2,500",
    suffix: "/year",
    title: "Uninterrupted growth.",
    sub: "Consistent access, significant savings.",
    subText: "Billed annually. Auto-renews.",
    features: ["All platform features", "Priority ad postings", "Calendar services", "Predictable billing", "Cancel anytime before renewal"],
    cta: "Choose Yearly Plan"
  },
  lifetime: {
    badge: "🔥 LIFETIME DEAL",
    orig: "Rs. 12,000/year",
    main: "4,999",
    suffix: "one-time",
    title: "Pay once. Use forever.",
    sub: "No monthly fees. No hidden charges.",
    subText: "For the first 5,000 women service providers only",
    features: ["Unlimited bookings", "Unlimited clients", "Razorpay + UPI payments", "Built-in video calls", "GST invoicing + PDF", "WhatsApp reminders", "Branded landing pages", "No monthly fees. Ever."],
    cta: "Claim Your Lifetime Access"
  }
};

const languages = [
  { code: "en", label: "English" }, { code: "hi", label: "हिंदी" }, { code: "ta", label: "தமிழ்" },
  { code: "te", label: "తెలుగు" }, { code: "kn", label: "ಕನ್ನಡ" }, { code: "ml", label: "മലയാളം" },
  { code: "mr", label: "मराठी" }, { code: "gu", label: "ગુજરાતી" }, { code: "bn", label: "বাংলা" },
  { code: "fr", label: "Français" }, { code: "es", label: "Español" },
];

// ─────────────────────────────────────────────────────────────────────────────
// MAIN COMPONENT
// ─────────────────────────────────────────────────────────────────────────────
const YuukkeLandingV2 = (props) => {
  const [activeTab, setActiveTab] = useState(0);
  const [tabKey, setTabKey] = useState(0);
  const [openFaq, setOpenFaq] = useState(null);
  const [loginModel, setLoginModel] = useState(false);
  const [contactSupportMenu, setContactSupportMenu] = useState(false);
  const [showStickyBar, setShowStickyBar] = useState(false);
  const [forceLoginEmail, setForceLoginEmail] = useState(null);
  const [lang, setLang] = useState("en");
  const [open, setOpen] = useState(false);
  const [activePricing, setActivePricing] = useState("lifetime");
  const [activeMenu, setActiveMenu] = useState(0); 
  const formRef = useRef(null);
  useScrollReveal();
  const { t } = props;

  useEffect(() => {
    const saved = localStorage.getItem("selectedLanguage") || "en";
    setLang(saved);
    i18n.changeLanguage(saved);
  }, []);

  useEffect(() => {
    const handleScroll = () => setShowStickyBar(window.scrollY > 600);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (sessionStorage.getItem("enquiryShown")) return;
    const handleMouseLeave = (e) => {
      if (e.clientY <= 0) {
        setContactSupportMenu(true);
        sessionStorage.setItem("enquiryShown", "true");
        document.removeEventListener("mouseleave", handleMouseLeave);
      }
    };
    document.addEventListener("mouseleave", handleMouseLeave);
    return () => document.removeEventListener("mouseleave", handleMouseLeave);
  }, []);

  const selectedLang = languages.find((l) => l.code === lang);
  const dispatch = useDispatch();
  const { categoryList, subscriptionList } = useSelector((state) => state.event);
  const { languagelist } = useSelector((state) => state.commonApi);

  useEffect(() => {
    dispatch(getSubscriptionList("service"));
    dispatch(getAllCommonLanguageList());
    dispatch(getCategoryListV2());
  }, [dispatch]);

  const scrollToForm = () => {
    if (formRef.current) {
      const yOffset = -90; 
      const y = formRef.current.getBoundingClientRect().top + window.scrollY + yOffset;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };

  return (
    <div className="yk2-root">
      <Helmet>
        <title>Yuukke | Find Women Coaches, Mentors &amp; Service Providers in India</title>
        <meta name="description" content="Discover verified women coaches, consultants, and service providers on Yuukke. Book sessions, pay via UPI, get GST invoices, and grow with India's leading women entrepreneur platform." />
        <meta name="keywords" content="women coaches India, women mentors India, service providers India, coaching platform India, women entrepreneurs, book coaching session, UPI payments coaching, GST invoice coaching, online coaching India, Yuukke" />
        <meta name="author" content="Yuukke" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://service.yuukke.com/yuukke-service" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Yuukke" />
        <meta property="og:locale" content="en_IN" />
        <meta property="og:title" content="Yuukke | Find Women Coaches & Service Providers in India" />
        <meta property="og:description" content="Book sessions with verified women coaches, consultants, and mentors. Pay via UPI. Automated GST invoicing included. India's #1 platform for women service providers." />
        <meta property="og:image" content="https://corporate.yuukke.com/bcav2/auth/image/22cb040b-f51d-47e6-8588-42eac1d8c909" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:image:alt" content="Yuukke - Women Coaches and Service Providers in India" />
        <meta property="og:url" content="https://service.yuukke.com/yuukke-service" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@Yuukke" />
        <meta name="twitter:creator" content="@Yuukke" />
        <meta name="twitter:title" content="Yuukke | Find Women Coaches & Service Providers in India" />
        <meta name="twitter:description" content="Book sessions with verified women coaches on Yuukke. Pay via UPI. GST invoicing included." />
        <meta name="twitter:image" content="https://corporate.yuukke.com/bcav2/auth/image/22cb040b-f51d-47e6-8588-42eac1d8c909" />
        <meta name="twitter:image:alt" content="Yuukke - Women Coaches and Service Providers in India" />
      </Helmet>

      {/* NAV */}
      <nav className="yk2-nav">
        <button type="button" className="yk2-nav-logo" style={{ background: "none", border: "none", padding: 0, cursor: "pointer" }} onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
          <img src={headerImg} alt="Yuukke" className="yk2-nav-logo-img" />
        </button>
        <div className="yk2-nav-links">
          <a href="#yk2-features">{t("Features")}</a>
          <a href="#yk2-pricing">{t("Pricing")}</a>
          <a href="#yk2-compare">{t("Compare")}</a>
          <a href="#yk2-faq">{t("FAQ")}</a>
          <a href="#yk2-getstarted">{t("Get Started")}</a>
        </div>
        <div className="yk2-nav-actions">
          <div className="yk2-lang-dropdown">
            <button className="yk2-lang-btn" onClick={() => setOpen(!open)}>{selectedLang.label}</button>
            {open && (
              <div className="yk2-lang-menu">
                {languages.map((l) => (
                  <div key={l.code} className={`yk2-lang-item ${lang === l.code ? "active" : ""}`} onClick={() => { setLang(l.code); setOpen(false); i18n.changeLanguage(l.code); localStorage.setItem("selectedLanguage", l.code); }}>{l.label}</div>
                ))}
              </div>
            )}
          </div>
          <button className="yk2-btn-ghost" onClick={() => setLoginModel(true)}>{t("Sign In")}</button>
          <button className="yk2-btn-primary yk2-rpl" onClick={(e) => { ripple(e); scrollToForm(); }}>{t("Start Now")}</button>
        </div>
      </nav>

      {/* HERO */}
      <section className="yk2-hero-wrap">
        <div className="yk2-hero">
          <div>
            <div className="yk2-hero-badge">{t("✨ For women who build")}</div>
            <h1 className="yk2-hero-title">{t("Your Business,")}<br /><span>{t("Beautifully Run.")}</span></h1>
            <p className="yk2-hero-sub">{t("The all-in-one platform for coaches, consultants, and service providers in India. Booking, payments, video calls, invoicing — one link, zero tech headaches.")}</p>
            <div className="yk2-hero-ctas">
              <button className="yk2-btn-primary yk2-rpl" onClick={(e) => { ripple(e); scrollToForm(); }}>{t("Start Now")}</button>
              <button className="yk2-btn-outline" onClick={scrollToForm}>{t("See how it works")}</button>
            </div>
            <p className="yk2-hero-note">{t("No credit card required · Set up in 5 minutes")}</p>
          </div>
          <div className="yk2-hero-card-wrap">
            <div className="yk2-hero-float">
              <div className="yk2-url-bar">
                <div className="yk2-url-dot" style={{ background: "#ff5f57" }} />
                <div className="yk2-url-dot" style={{ background: "#febc2e" }} />
                <div className="yk2-url-dot" style={{ background: "#28c840" }} />
                <span className="yk2-url-text">yuukke.com/your-name</span>
              </div>
              <div className="yk2-mock-card">
                <div className="yk2-svc-list">
                  {[["1:1 Coaching", "₹2,500"], ["Group Session", "₹1,000"], ["Strategy Call", "₹5,000"]].map(([n, p]) => (
                    <div className="yk2-svc-item" key={n}><span className="yk2-svc-name">{n}</span><span className="yk2-svc-price">{p}</span></div>
                  ))}
                </div>
                <button className="yk2-book-btn yk2-rpl" onClick={ripple}>{t("Book Now")}</button>
                <div className="yk2-pay-badge">💚 {t("Payment received")} &nbsp;<strong>+₹2,500</strong></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* TICKER */}
      <div style={{ background: "#fff", borderTop: "1px solid #f0dde3", borderBottom: "1px solid #f0dde3", padding: ".65rem 0", overflow: "hidden", position: "relative" }}>
        <div style={{ position: "absolute", left: 0, top: 0, bottom: 0, width: 80, background: "linear-gradient(to right, #fff, transparent)", zIndex: 2, pointerEvents: "none" }} />
        <div style={{ position: "absolute", right: 0, top: 0, bottom: 0, width: 80, background: "linear-gradient(to left, #fff, transparent)", zIndex: 2, pointerEvents: "none" }} />
        <div style={{ display: "flex", width: "max-content", animation: "yk2-ticker 28s linear infinite" }}>
          {[...Array(2)].map((_, repeatIdx) => (
            <div key={repeatIdx} style={{ display: "flex", alignItems: "center" }}>
              {[{ icon: "👩‍💼", text: "Sneha from Bangalore just registered" }, { icon: "💳", text: "₹2,500 booking completed · 2 min ago" }, { icon: "⭐", text: "Priya rated her session 5 stars" }, { icon: "🎉", text: "Divya got her first client today" }, { icon: "📅", text: "Meera booked a Strategy Call" }, { icon: "🚀", text: "Ananya launched her coaching page" }].map((item, i) => (
                <span key={i} style={{ fontSize: ".85rem", color: "#6b4550", padding: "0 2.5rem", display: "flex", alignItems: "center", gap: ".5rem", whiteSpace: "nowrap" }}>
                  <span>{item.icon}</span><span>{t(item.text)}</span><span style={{ marginLeft: "2rem", color: "#f0dde3", fontSize: "1.2rem" }}>•</span>
                </span>
              ))}
            </div>
          ))}
        </div>
      </div>

      {/* FEATURED IN */}
      <div className="yk2-featured">
        <div className="yk2-featured-container">
          <p className="yk2-featured-title">{t("Featured In")}</p>
          <div className="yk2-featured-logos">
            {[{ src: entrepreneur, alt: "Entrepreneur" }, { src: toi, alt: "Times of India" }, { src: yourStory, alt: "YourStory" }, { src: zeeNews, alt: "Zee News" }, { src: dtNext, alt: "DT Next" }].map((logo, index) => (
              <div className="yk2-logo-item" key={index}><img src={logo.src} alt={logo.alt} /></div>
            ))}
          </div>
        </div>
      </div>

      {/* PROBLEM / SOLUTION */}
      <div className="yk2-section">
        <div className="yk2-section-tag yk2-reveal">{t("Problem → Solution")}</div>
        <h2 className="yk2-section-h2 yk2-reveal yk2-d1">{t("Sound familiar? We can fix that.")}</h2>
        <p className="yk2-section-sub yk2-reveal yk2-d2">{t("You started your business to help people — not to fight with technology.")}</p>
        <div className="yk2-ps-grid">
          <div className="yk2-ps-card yk2-ps-without yk2-reveal-left yk2-d2">
            <div className="yk2-ps-label">{t("❌ Without Yuukke")}</div>
            {["Juggling WhatsApp, spreadsheets, and payment links", "Sending manual payment reminders and invoices", "No professional online presence for your business", "Paying for 5 different tools that barely work together"].map((text) => (
              <div className="yk2-ps-item" key={text}>{t(text)}</div>
            ))}
          </div>
          <div className="yk2-ps-card yk2-ps-with yk2-reveal-right yk2-d2">
            <div className="yk2-ps-label">{t("✅ With Yuukke")}</div>
            {["One dashboard for bookings, clients, and payments", "Automated invoicing with UPI and Razorpay", "A beautiful branded page ready in 5 minutes", "Everything in one platform, one lifetime price"].map((text) => (
              <div className="yk2-ps-item" key={text}>{t(text)}</div>
            ))}
          </div>
        </div>
      </div>

      <ServicePageShowcase />

      {/* FEATURES */}
      <div className="yk2-feat-section" id="yk2-features">
        <div className="yk2-feat-inner">
          <div className="yk2-section-tag yk2-reveal">{t("Features")}</div>
          <h2 className="yk2-section-h2 yk2-reveal yk2-d1">{t("Everything you need. All in one place.")}</h2>
          <p className="yk2-section-sub yk2-reveal yk2-d2">{t("Booking, payments, video calls, invoicing, CRM — no more switching between apps.")}</p>
          <div className="yk2-feat-tabs yk2-reveal yk2-d3">
            {FEATURES.map((f, i) => (
              <button key={f.tab} className={`yk2-tab-btn${activeTab === i ? " yk2-tab-active" : ""}`} onClick={() => { setActiveTab(i); setTabKey((k) => k + 1); }}>{t(f.tab)}</button>
            ))}
          </div>
          <div className="yk2-feat-content" key={tabKey}>
            <div>
              <h3 className="yk2-feat-title">{t(FEATURES[activeTab].title)}</h3>
              <p className="yk2-feat-desc">{t(FEATURES[activeTab].desc)}</p>
              <ul className="yk2-feat-points">{FEATURES[activeTab].points.map((p) => (<li key={p}>{t(p)}</li>))}</ul>
            </div>
            <div className="yk2-feat-visual">{FEATURES[activeTab].visual}</div>
          </div>
        </div>
      </div>

      {/* HOW IT WORKS */}
      <div className="yk2-section">
        <div className="yk2-section-tag yk2-reveal">{t("How it works")}</div>
        <h2 className="yk2-section-h2 yk2-reveal yk2-d1">{t("Set up in minutes. Start getting bookings today.")}</h2>
        <div className="yk2-steps-grid">
          {[["01", "Create your profile", "Add your name, photo, and a beautiful bio. Pick your brand colors."], ["02", "List your services", "One-off sessions, coaching packages, or group workshops — your call."], ["03", "Share your link", "One link for WhatsApp, Instagram bio, email signature — everywhere."], ["04", "Get booked & paid", "Clients book a slot, pay instantly via UPI, and you focus on what you do best."]].map(([num, title, desc], i) => (
            <div className={`yk2-step-card yk2-reveal yk2-d${i + 1}`} key={num}>
              <div className="yk2-step-num">Step {num}</div>
              <div className="yk2-step-title">{t(title)}</div>
              <div className="yk2-step-desc">{t(desc)}</div>
            </div>
          ))}
        </div>
      </div>

      {/* PRICING */}
      <div className="yk2-pricing-wrap" id="yk2-pricing">
        <div className="yk2-pricing-inner">
          <div className="yk2-pricing-tag yk2-reveal">{t("Pricing")}</div>
          <h2 className="yk2-pricing-h2 yk2-reveal yk2-d1">{t(PRICING_CONTENT[activePricing].title)}</h2>
          <p className="yk2-pricing-h2sub yk2-reveal yk2-d2">{t(PRICING_CONTENT[activePricing].sub)}</p>

          <div className="yk2-pricing-toggle-wrap yk2-reveal yk2-d2">
            <button className={`yk2-pricing-toggle-btn ${activePricing === "free" ? "active" : ""}`} onClick={() => setActivePricing("free")}>{t("Free Trial")}</button>
            <button className={`yk2-pricing-toggle-btn ${activePricing === "yearly" ? "active" : ""}`} onClick={() => setActivePricing("yearly")}>{t("Yearly")}</button>
            <button className={`yk2-pricing-toggle-btn ${activePricing === "lifetime" ? "active" : ""}`} onClick={() => setActivePricing("lifetime")}>{t("Lifetime")}</button>
          </div>

          <div className="yk2-pricing-card" key={activePricing}>
            <div className="yk2-pricing-badge">{t(PRICING_CONTENT[activePricing].badge)}</div>
            <div className="yk2-price-orig">{PRICING_CONTENT[activePricing].orig}</div>
            <div className="yk2-price-main"><span>₹</span>{PRICING_CONTENT[activePricing].main}<span style={{ fontSize: "1rem", color: "#6b4550", fontFamily: "DM Sans" }}>&nbsp;{t(PRICING_CONTENT[activePricing].suffix)}</span></div>
            <div className="yk2-price-sub">{t(PRICING_CONTENT[activePricing].subText)}</div>
            <div className="yk2-price-feats">
              {PRICING_CONTENT[activePricing].features.map((f) => (
                <div className="yk2-price-feat" key={f}>{t(f)}</div>
              ))}
            </div>
            <button className="yk2-pricing-cta yk2-rpl" onClick={(e) => { ripple(e); scrollToForm(); }}>{t(PRICING_CONTENT[activePricing].cta)}</button>
            <div className="yk2-pricing-note">{t("14-day free trial · No credit card required")}</div>
          </div>
        </div>
      </div>

      {/* TESTIMONIALS */}
      <div className="yk2-section">
        <div className="yk2-section-tag yk2-reveal">{t("Testimonials")}</div>
        <h2 className="yk2-section-h2 yk2-reveal yk2-d1">{t("Hear from women who use Yuukke every day.")}</h2>
        <div className="yk2-testi-grid">
          {TESTIMONIALS.map((t2, i) => (
            <div className={`yk2-testi-card yk2-reveal yk2-d${i + 1}`} key={t2.name}>
              <div className="yk2-quote-mark">"</div>
              <p className="yk2-testi-text">{t2.quote}</p>
              <div className="yk2-testi-author">
                <div className="yk2-author-av">{t2.initials}</div>
                <div><div className="yk2-author-name">{t2.name}</div><div className="yk2-author-role">{t2.role}</div></div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <BlogSection t={t} />

      {/* COMPARE */}
      <div className="yk2-compare-wrap" id="yk2-compare">
        <div className="yk2-compare-inner">
          <div className="yk2-section-tag yk2-reveal">{t("Compare")}</div>
          <h2 className="yk2-section-h2 yk2-reveal yk2-d1">{t("Why Yuukke? See how we compare.")}</h2>
          <div className="yk2-compare-table-scroll">
            <table className="yk2-compare-table yk2-reveal yk2-d2">
              <thead>
                <tr><th>{t("Feature")}</th><th className="yk2-col-yk">Yuukke</th><th>Calendly</th><th>HoneyBook</th><th>Dubsado</th></tr>
              </thead>
              <tbody>
                {COMPARE.map((row, i) => (
                  <tr key={row.feature} style={{ animation: `yk2-rowSlide .4s ease ${i * 0.06}s both` }}>
                    <td style={{ fontWeight: 500 }}>{t(row.feature)}</td><td className="yk2-col-yk">{row.yuukke}</td><td>{row.calendly}</td><td>{row.honeybook}</td><td>{row.dubsado}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* GET STARTED */}
      <div className="yk2-getstarted-section" id="yk2-getstarted" ref={formRef}>
        <div style={{ maxWidth: 1200, margin: "0 auto", marginBottom: "3rem", textAlign: "center" }}>
          <div className="yk2-section-tag yk2-reveal" style={{ display: "inline-block" }}>{t("Become a Service Provider")}</div>
          <h2 className="yk2-section-h2 yk2-reveal yk2-d1" style={{ maxWidth: "100%" }}>{t("Start your professional journey today ✨")}</h2>
          <p className="yk2-section-sub yk2-reveal yk2-d2" style={{ maxWidth: "100%" }}>{t("Join a growing network of verified women service providers and grow your business with Yuukke.")}</p>
        </div>
        <div className="yk2-getstarted-inner">
          <div className="yk2-gs-left yk2-reveal-left yk2-d2">
            <div className="yk2-stepper">
              {STEP_INFO.map((s, i) => (
                <div className="yk2-stepper-item" key={i}>
                  <div className="yk2-stepper-icon-col">
                    <div className="yk2-stepper-icon"><span style={{ fontSize: "1.3rem" }}>{s.icon}</span></div>
                    {i < STEP_INFO.length - 1 && <div className="yk2-stepper-line" />}
                  </div>
                  <div className="yk2-stepper-text">
                    <div className="yk2-stepper-title">{t(s.title)}</div>
                    <div className="yk2-stepper-sub">{t(s.sub)}</div>
                  </div>
                </div>
              ))}
            </div>
            <div>
              <p style={{ fontSize: ".85rem", marginBottom: ".75rem", fontWeight: 600 }}>📽️ See how Yuukke works in 2 minutes</p>
              <VideoPlayer />
            </div>
          </div>
          <div className="yk2-form-card yk2-reveal-right yk2-d2">
            {/* The form wrapper now ignores clicks as scroll handles inside the form itself */}
            <div>
                <RegistrationForm 
                  subscriptionList={subscriptionList} 
                  languagelist={languagelist} 
                  categoryList={categoryList} 
                  onForceLogin={(email) => { setForceLoginEmail(email); setLoginModel(true); }} 
                  scrollToForm={scrollToForm}
                />
            </div>
          </div>
        </div>
      </div>

      {/* FAQ */}
      <div className="yk2-faq-wrap" id="yk2-faq">
        <div className="yk2-section-tag yk2-reveal">{t("FAQ")}</div>
        <h2 className="yk2-section-h2 yk2-reveal yk2-d1">{t("Questions? We have answers.")}</h2>
        <div style={{ marginTop: "2.5rem" }}>
          {FAQS.map((faq, i) => (
            <div className={`yk2-faq-item yk2-reveal yk2-d${Math.min(i + 1, 6)}`} key={i}>
              <button className="yk2-faq-q" onClick={() => setOpenFaq(openFaq === i ? null : i)}>
                {t(faq.q)}<span className={`yk2-faq-icon${openFaq === i ? " yk2-open" : ""}`}>+</span>
              </button>
              <div className={`yk2-faq-a-wrap${openFaq === i ? " yk2-open" : ""}`}><div className="yk2-faq-a">{t(faq.a)}</div></div>
            </div>
          ))}
        </div>
      </div>

      {/* FINAL CTA */}
      <div className="yk2-cta-section">
        <h2 className="yk2-cta-title yk2-reveal">{t("Start getting paid for your sessions — without the tech stress")}</h2>
        <p className="yk2-cta-sub yk2-reveal yk2-d1">{t("Join 500+ women coaches who are already booking clients, collecting payments, and managing everything from one simple page.")}</p>
        <div className="yk2-cta-btns yk2-reveal yk2-d2">
          <button className="yk2-btn-primary yk2-rpl" onClick={(e) => { ripple(e); scrollToForm(); }} style={{ fontSize: "1rem", padding: ".85rem 2rem", borderRadius: 12 }}>{t("Create your page")}</button>
          <button className="yk2-btn-outline" style={{ fontSize: "1rem", padding: ".85rem 2rem", borderRadius: 12 }} onClick={() => { window.open(`https://wa.me/919150625864?text=${encodeURIComponent("Hi, I want to understand how Yuukke works before I start.")}`, "_blank"); }}>{t("Chat on WhatsApp")}</button>
        </div>
        <p className="yk2-cta-note yk2-reveal yk2-d3">{t("⭐ No tech setup needed · ₹4,999 lifetime")}</p>
      </div>

      {/* FOOTER */}
      <footer className="yk2-footer">
        <div className="yk2-footer-inner">
          <div>
            <div className="yk2-footer-logo">Yuukke</div>
            <div className="yk2-footer-desc">{t("A digital platform empowering women professionals to start, manage, and grow their service-based businesses.")}</div>
            <div className="yk2-footer-contact-block">
              <div className="yk2-footer-contact-label">{t("Contact Us")}</div>
              <div className="yk2-footer-contact-item">📞 7305888112 / 7305888114 / 919150625864</div>
              <div className="yk2-footer-contact-item"><a href="mailto:support@yuukke.com" style={{ color: "rgba(160,0,48,0.85)" }}>support@yuukke.com</a></div>
            </div>
            <div className="yk2-footer-social-row">
              {[{ href: "https://www.facebook.com/YUUKKEGLOBAL", label: "FB" }, { href: "https://instagram.com/yuukkeglobal", label: "IG" }, { href: "https://www.linkedin.com/company/yuukke/", label: "LI" }, { href: "https://www.youtube.com/@yuukkeglobal", label: "YT" }].map((s) => (
                <a key={s.label} href={s.href} className="yk2-footer-social-icon" style={{ color: "rgba(255,255,255,0.5)", fontSize: 11, fontWeight: 600 }}>{s.label}</a>
              ))}
            </div>
          </div>
          {[
            { title: "Join Yuukke", links: [["As a Seller", "https://marketplace.yuukke.com/seller_register"], ["As a Member", "https://login.yuukke.com/"], ["As a Mentor", "https://yuukke.com/become-a-mentor/"]] },
            { title: "Programs", links: [["About Yuukke", "https://yuukke.com/about/"], ["Blogs", "https://yuukke.com/blog/"], ["Events", "https://yuukke.com/#events"]] },
            { title: "About", links: [["Featured In", "https://yuukke.com/women-leaders-2023/"], ["Contact Us", "https://yuukke.com/contact-us/"]] },
            { title: "Support", links: [["Why Yuukke", "https://yuukke.com/#why-yuukke"], ["Get Involved", "https://yuukke.com/#get-involved"], ["What We Do", "https://yuukke.com/#what-we-do"], ["Meet & Greet", "https://yuukke.com/meet-greet/"]] },
            { title: "Social", links: [["Facebook", "https://www.facebook.com/YUUKKEGLOBAL"], ["Instagram", "https://instagram.com/yuukkeglobal"], ["LinkedIn", "https://www.linkedin.com/company/yuukke/"], ["YouTube", "https://www.youtube.com/@yuukkeglobal"]] }
          ].map((col) => (
            <div key={col.title}>
              <div className="yk2-footer-col-h">{t(col.title)}</div>
              <ul className="yk2-footer-links">{col.links.map(([label, href]) => (<li key={label}><a href={href}>{t(label)}</a></li>))}</ul>
            </div>
          ))}
        </div>
        <div className="yk2-footer-mid">
          <div><div style={{ fontSize: 11, fontWeight: 700, letterSpacing: "0.08em", textTransform: "uppercase", color: "rgba(255,255,255,0.3)" }}>{t("Get the App")}</div><div style={{ fontSize: 13, color: "rgba(255,255,255,0.45)", marginTop: 2 }}>{t("Available on iOS & Android")}</div></div>
          <div style={{ display: "flex", gap: 10 }}>
            <a className="yk2-app-badge" href="https://apps.apple.com/in/app/yuukke/id1620476926"><img src={appleStore} alt="App Store" style={{ width: 22, opacity: 0.8 }} /><div><span className="yk2-app-badge-sub">{t("Download on the")}</span><span className="yk2-app-badge-name">{t("App Store")}</span></div></a>
            <a className="yk2-app-badge" href="https://play.google.com/store/apps/details?id=com.betamonks.yuukee"><img src={playStore} alt="Google Play" style={{ width: 22, opacity: 0.8 }} /><div><span className="yk2-app-badge-sub">{t("Get it on")}</span><span className="yk2-app-badge-name">{t("Google Play")}</span></div></a>
          </div>
        </div>
        <div className="yk2-footer-bottom">
          <span>{t("© 2022–2026 Yuukke Global Ventures Private Limited.")}</span>
          <span><a href="https://yuukke.com/wp-content/uploads/2024/02/yuukke_tnc.pdf">{t("Terms")}</a>{" • "}<a href="https://yuukke.com/wp-content/uploads/2022/12/Yuukke-Privacy-Policy.pdf">{t("Privacy")}</a></span>
        </div>
      </footer>

      {loginModel && <ServiceLoginModel closeModel={() => setLoginModel(false)} presetEmail={forceLoginEmail} />}
      <div className={`yk2-sticky-bar${showStickyBar ? " visible" : ""}`}>
        <div className="yk2-sticky-bar-text"><strong>🔥 Lifetime deal at ₹4,999</strong> — {t("Limited to first 5,000 providers")}</div>
        <button className="yk2-btn-primary yk2-rpl" style={{ fontSize: ".9rem", padding: ".6rem 1.6rem", borderRadius: 8, background: "#fff", color: "#7a0024" }} onClick={(e) => { ripple(e); scrollToForm(); }}>{t("Claim Now →")}</button>
      </div>
      <EnquiryDialog open={contactSupportMenu} onClose={() => setContactSupportMenu(false)} t={t} />
    </div>
  );
};

export default withTranslation()(withRouter(YuukkeLandingV2));
